import React, {useEffect, useState} from 'react';

import {
  useCurrentUserState,
  useUpdateUserTourStatus,
} from 'app/current-user/api';
import {gt} from 'app/utils/i18n';

import {UserAvailableTours} from 'sweet-types';

export function AssignToStepsNewFeatureAlert() {
  return (
    // maxUserId obtained on 13 Oct 19:07 UTC
    <ShowToUserOnceOnly tourname="assign_steps" maxUserId={381092}>
      {(hide) => (
        <div className="alert alert-info small">
          <h5 className="alert-heading">
            {gt('Now you can assign to steps')} 🎉
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={() => hide()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </h5>
          {gt('Try it out by checking off the checkbox below')}
        </div>
      )}
    </ShowToUserOnceOnly>
  );
}

interface ShowToUserOnceOnlyProps {
  tourname: UserAvailableTours;
  maxUserId?: number;
  children: (hide: () => unknown) => JSX.Element;
}

function ShowToUserOnceOnly({
  tourname,
  maxUserId,
  children,
}: ShowToUserOnceOnlyProps) {
  const {tours, id} = useCurrentUserState().data!;
  const [updateUserTourStatus] = useUpdateUserTourStatus();

  const tour = tours[tourname];

  const isNewUser = maxUserId != null && id > maxUserId;
  const isTourFinished = tour?.status === 'finished';

  const [hidden, hide] = useState(() => isNewUser || isTourFinished);

  useEffect(() => {
    if (!hidden || (isNewUser && !isTourFinished)) {
      updateUserTourStatus({
        tourname,
        tourversion: tour?.version ?? 0,
        status: 'finished',
      });
    }
  }, []);

  if (hidden) {
    return null;
  }

  return children(() => hide(true));
}
